import React from 'react'

interface Props {
    children: React.ReactNode
    showIf?: boolean
}

export const If = ({ children, showIf }: Props) => showIf ? <>{children}</> : null
